import TopNavigation, { TopNavigationProps } from '@cloudscape-design/components/top-navigation';
import { useCapabilities } from '../capabilities';
import { navigate, settingsPath, uploadPath } from '../router';
import { APP_HEADER_ID } from '../constants';

const HEADER_Z_INDEX = 1002;

export interface AppHeaderProps {
  readonly alias: string;
  readonly authenticated: boolean;
}

export function AppHeader({ alias, authenticated }: AppHeaderProps) {
  const { canCreate } = useCapabilities();
  const utilities: TopNavigationProps.Utility[] = authenticated
    ? [
        { type: 'button', text: 'Home', ariaLabel: 'Home', onClick: () => navigate('/') },
        ...(canCreate
          ? [
              {
                type: 'button' as const,
                text: 'Upload',
                iconName: 'upload' as const,
                ariaLabel: 'Upload report',
                onClick: () => navigate(uploadPath()),
              },
            ]
          : []),
        {
          type: 'button',
          text: 'Email preferences',
          ariaLabel: 'Email preferences',
          onClick: () => navigate(settingsPath()),
        },
        {
          type: 'menu-dropdown',
          text: alias || 'Account',
          iconName: 'user-profile',
          ariaLabel: 'Signed in user',
          items: [{ id: 'identity', text: alias ? `Signed in as ${alias}` : 'Signed in', disabled: true }],
        },
      ]
    : [];

  return (
    <div id={APP_HEADER_ID} style={{ position: 'sticky', top: 0, zIndex: HEADER_Z_INDEX }}>
      <TopNavigation
        identity={{
          href: '/',
          title: 'SENTRIA',
          logo: { src: '/sentria-icon.png', alt: 'SENTRIA' },
          onFollow: (event) => {
            event.preventDefault();
            navigate('/');
          },
        }}
        utilities={utilities}
      />
    </div>
  );
}
